import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import bcrypt from 'bcryptjs';

const CreateTestUser = () => {
  const [message, setMessage] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const navigate = useNavigate();

  const createAdminUser = async () => {
    setIsCreating(true);
    try {
      // Create a hashed password
      const salt = await bcrypt.genSalt(10);
      const hashedPassword = await bcrypt.hash('admin123', salt);
      
      // Create admin user
      const adminUser = {
        id: Date.now(),
        name: 'Admin User',
        email: 'admin@example.com',
        password: hashedPassword,
        role: 'admin',
        status: 'approved'
      };
      
      // Save to localStorage
      const users = JSON.parse(localStorage.getItem('users') || '[]');
      
      // Check if user already exists
      if (users.some(user => user.email === adminUser.email)) {
        setMessage('Admin user already exists! You can login with admin@example.com and password: admin123');
      } else {
        users.push(adminUser);
        localStorage.setItem('users', JSON.stringify(users));
        setMessage('Admin user created successfully! Email: admin@example.com, Password: admin123');
      }
    } catch (error) {
      setMessage('Error creating user: ' + error.message);
    } finally {
      setIsCreating(false);
    }
  };

  const createViewerUser = async () => {
    setIsCreating(true);
    try {
      // Create a hashed password
      const salt = await bcrypt.genSalt(10);
      const hashedPassword = await bcrypt.hash('viewer123', salt);
      
      // Create viewer user
      const viewerUser = {
        id: Date.now(),
        name: 'Viewer User',
        email: 'viewer@example.com',
        password: hashedPassword,
        role: 'viewer',
        status: 'approved'
      };
      
      // Save to localStorage
      const users = JSON.parse(localStorage.getItem('users') || '[]');
      
      // Check if user already exists
      if (users.some(user => user.email === viewerUser.email)) {
        setMessage('Viewer user already exists! You can login with viewer@example.com and password: viewer123');
      } else {
        users.push(viewerUser);
        localStorage.setItem('users', JSON.stringify(users));
        setMessage('Viewer user created successfully! Email: viewer@example.com, Password: viewer123');
      }
    } catch (error) {
      setMessage('Error creating user: ' + error.message);
    } finally {
      setIsCreating(false);
    }
  };

  const goToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="max-w-md mx-auto my-12 p-8 bg-white rounded-xl shadow-lg">
      <h2 className="text-2xl font-bold mb-6 text-center text-purple-700">Create Test Users</h2>
      
      {message && (
        <div className="mb-6 p-4 bg-green-50 border-l-4 border-green-500 text-green-700 rounded">
          {message}
        </div>
      )}
      
      <div className="space-y-4">
        <button
          onClick={createAdminUser}
          disabled={isCreating}
          className="w-full bg-purple-600 hover:bg-purple-700 text-white font-medium py-3 px-4 rounded-lg transition-colors duration-300 flex justify-center items-center"
        >
          {isCreating ? 'Creating...' : 'Create Admin User'}
        </button>
        
        <button
          onClick={createViewerUser}
          disabled={isCreating}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg transition-colors duration-300 flex justify-center items-center"
        >
          {isCreating ? 'Creating...' : 'Create Viewer User'}
        </button>
        
        <button
          onClick={goToLogin}
          className="w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-3 px-4 rounded-lg transition-colors duration-300 mt-4"
        >
          Go to Login Page
        </button>
      </div>
    </div>
  );
};

export default CreateTestUser;
